import _styled from "@emotion/styled/base";
import React from "react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16 .611 15.426 0 8 7.408.612 0 0 .611l7.388 7.408L0 15.39l.612.61L8 8.592 15.426 16l.574-.611-7.388-7.37z",
    fillRule: "evenodd"
  }));
};
CloseIcon.defaultProps = {
  fill: "#fff",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
export const StyledCloseButton = /*#__PURE__*/_styled(CloseIcon, process.env.NODE_ENV === "production" ? {
  target: "e1yvcnez0"
} : {
  target: "e1yvcnez0",
  label: "StyledCloseButton"
})(process.env.NODE_ENV === "production" ? {
  name: "12n878b",
  styles: "position:absolute;inset-block-start:-10px;inset-inline-end:-10px;inline-size:24px;block-size:24px;padding:4px;border-radius:50%;background-color:#222222;cursor:pointer"
} : {
  name: "12n878b",
  styles: "position:absolute;inset-block-start:-10px;inset-inline-end:-10px;inline-size:24px;block-size:24px;padding:4px;border-radius:50%;background-color:#222222;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWtEIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IENsb3NlSWNvbiBmcm9tIFwiLi9pY29uLWNsb3NlLnN2Z1wiO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkQ2xvc2VCdXR0b24gPSBzdHlsZWQoQ2xvc2VJY29uKWBcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICBpbnNldC1ibG9jay1zdGFydDogLTEwcHg7XG4gIGluc2V0LWlubGluZS1lbmQ6IC0xMHB4O1xuXG4gIGlubGluZS1zaXplOiAyNHB4O1xuICBibG9jay1zaXplOiAyNHB4O1xuICBwYWRkaW5nOiA0cHg7XG5cbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuXG4gIGJhY2tncm91bmQtY29sb3I6ICMyMjIyMjI7XG5cbiAgY3Vyc29yOiBwb2ludGVyO1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});